import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { LoginService } from 'src/app/services/login.service';
import { SlideService } from 'src/app/services/slide.service';

@Component({
  selector: 'app-gift-card-home',
  templateUrl: './gift-card-home.component.html',
  styleUrls: ['./gift-card-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftCardHomeComponent implements OnInit, AfterViewInit {
  @ViewChild('slideGift') slideGift: IonSlides;
  @Input() data = undefined;
  @Input() section: any[] = undefined;
  @ViewChild('slidesGiftCard') slidesGiftCard: IonSlides

  public slideOpts: any = {}

  public reachedEnd = false;
  public isStart = true;

  constructor(
    public loginSv: LoginService,
    private cdr: ChangeDetectorRef,
    private slideSv: SlideService
  ) { }

  ngOnInit() {
  }

  async slideTo(direction){
    await direction ? this.slidesGiftCard.slideNext(400) : this.slidesGiftCard.slidePrev(400);
  }

  async changedSlide(ev){
    this.reachedEnd = ev.el.dom7ElementDataStorage.swiper.isEnd;
    if(!this.reachedEnd || this.reachedEnd){
      this.isStart = ev.el.dom7ElementDataStorage.swiper.isBeginning;
    }
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    setTimeout(async() => {
      this.reachedEnd = await this.slideSv.isEnd(this.slideGift);
      this.cdr.detectChanges();
    })
  }
  
}
